import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import {EventBus} from '../../lib/event-bus';
let _ = require('lodash');
// initial state
const state = {
	polls: [],
	questions: [],
	quizSettings: [],
	my_answers: [],
	response_id: 0,
	answer_confirmed: {
		is_confirmed: false,
		is_correct: false,
		display: true,
		correct_answer: '',
	},
	last_answer_given: 0,
	quiz_finished: false,
	percentage: 0,
	score: 0,
	user_responses: [],
	responses: [],
	edit: false,
	all_user_responses: [],
};

// getters
const getters = {
	getPollById: (state) => (id) => {
		if (state.polls.length > 0) {
			return state.polls.find(polls => polls.id === parseInt(id));
		}
		return undefined;
	},
	getResponseById: (state) => (id) => {
		return state.responses[id][0];
	},
	getGivenAnswersByPollId: (state) => (id) => {
		if (state.my_answers.length > 0) {
			let answers = state.my_answers.find(my_answers => my_answers.quiz_id === id);

			return answers ? answers.user_responses : [];
		}

		return [];
	},
	getUserResponsesById: (state) => (id) => {
		if (state.all_user_responses.length > 0) {
			return state.all_user_responses[id];
		}
		return false;
	},
	getResponsesForOptionById: (state) => (payload) => {
		if (state.all_user_responses.length > 0) {
			return state.all_user_responses[payload.poll_id][0].find(response => response.question_option_id === payload.option_id);
		}
		return false;
	},
	getResponsesByQuestionId: (state) => (val) => {
		return state.user_responses.find(response => response.option_value === val);
	},
	getPollSettingsByPollId: (state) => (val) => {
		return state.quizSettings.find(quizSettings => quizSettings.quiz_id === val);
	},
	getUsersForOptionById: (state) => (payload) => {
		if (state.all_user_responses.length > 0) {
			return state.all_user_responses[payload.poll_id][0].find(response => response.question_option_id === payload.option_id);
		}
		return false;
	},
	getUserResponseByAnswerId: (state) => (payload) => {
		let quiz = state.my_answers.find(answer => answer.quiz_id === payload.poll_id);
		let user_response = quiz.user_responses.find(user_response => user_response.question_option_id === payload.question_option_id);

		return user_response.id;
	},
	getResponseIdByAnswerId: (state) => (payload) => {
		let quiz = state.my_answers.find(answer => answer.quiz_id === payload.poll_id);

		return quiz.response_id;
	},
};

// mutations
const mutations = {
	setPoll(state, payload) {
		state.polls.push(payload.data);
	},
	setPollSettings(state, payload) {
		let quiz_id = payload.quiz_id;
		state.quizSettings.push({
			'quiz_id': quiz_id,
			'setting': payload.response
		});
	},
	updateResponseId(state, payload) {
		if (state.response_id === 0) {
			state.response_id = payload;
		}
	},
	setGivenAnswers(state, payload) {
		// state.given_answers.push(payload.data.data);
	},
	confirmAnswer(state, payload) {
		if(state.quizSettings.direct_feedback === '1') {
			state.answer_confirmed.display = true;
			state.answer_confirmed.is_confirmed = true;
			state.answer_confirmed.is_correct = payload.is_correct;

			//if we want to display the correct answer and the answer is not correct
			if(state.quizSettings.correct_answer_feedback === '1' && !payload.is_correct) {
				if(payload.correct_question_option_id) {
					state.answer_confirmed.correct_answer = payload.correct_question_option_id;
				} else {
					state.answer_confirmed.correct_answer = payload.correct_answer;
				}
			}
		}
	},
	updateProgress(state, payload) {
		if(!Array.isArray(payload.data.data)) {
			let existing_answer_index = state.my_answers.findIndex(my_answers => my_answers.id === payload.data.data.id);

			if(existing_answer_index !== -1) {
				state.my_answers.splice(existing_answer_index, 1);
			}

			state.my_answers.push(payload.data.data);
		} else {
			state.my_answers = [];
		}
	},
	setQuestions(state, payload) {
		let quiz_id = payload.quiz_id;

		if(typeof state.questions[quiz_id] == 'undefined'){
			state.questions[quiz_id] = [];
		}
		state.questions[quiz_id].push(payload.data.data);
	},
	endQuiz(state,payload) {
		state.quiz_finished = true;

		if(payload.data.score) {
			state.percentage = payload.data.score.percentage;
			state.score = payload.data.score.score;
		}
	},
	setResponseId(state,payload) {
		state.response_id = payload;
	},
	setResponses(state,payload) {
		let quiz_id = payload.quiz_id;

		if(typeof state.responses[quiz_id] == 'undefined'){
			state.responses[quiz_id] = [];
		}
		state.responses[quiz_id].push(payload);
	},
	setUserResponses(state,payload) {
		state.user_responses = payload;
	},
	setAllUserResponses(state, payload){
		let quiz_id = payload.quiz_id;

		state.all_user_responses[quiz_id] = [];

		Vue.set(state.all_user_responses, quiz_id, [payload.response]);
	},
	setQuestionMedia(state, payload) {
		// for (let i = 0; i < payload.length; i++) {
		//     state.question_media.push(payload[i]);
		// }
	},
	editPoll(state,payload) {
		state.edit = payload;
	},

	syncPoll(state, payload) {
		let poll = state.polls.find(polls => polls.id === payload.id);

		poll.questions[0].question_options = [];

		for(let i = 0; i < payload.questions[0].question_options.length; i++) {
			poll.questions[0].question_options.push(payload.questions[0].question_options[i]);
		}
	},

	syncPollSettings(state, payload) {
		let poll_settings = state.quizSettings.find(setting => setting.quiz_id === payload.poll_id);

		poll_settings.setting = {};

		for(let i = 0; i < payload.data.length; i++) {
			poll_settings.setting[payload.data[i].setting] = payload.data[i].value;
		}
	},

	filterAnswer(state, payload) {
		state.my_answers = state.my_answers.filter(my_answer => my_answer.response_id !== payload.response_id);
	}
};

// actions
const actions = {
	getPoll({commit}, payload) {
		// TODO: quiz_id meegeven
		let id = payload;
		return axios.get('/api/v3/quiz-maker/quizzes/' + id)
			.then(function (response) {
				commit('setPoll', response.data);
				return response;
			}).catch((response) => {
			});
	},

	syncPoll({commit}, poll_id) {
		return new Promise((resolve, reject) => {
			axios.get('/api/v3/quiz-maker/quizzes/' + poll_id)
				.then(function (response) {
					commit('syncPoll', response.data.data);

					resolve(response);
				}).catch((response) => {
				});
		});
	},

	// To get the quiz settings, the state quiz must be updated first
	getPollSettings({commit}, payload) {
		return axios.get('/api/v3/quiz-maker/quizzes/' + payload + '/settings')
			.then(function (response) {
				let data = {
					response: response.data.data,
					quiz_id: payload
				};
				commit('setPollSettings', data);
			}).catch((response) => {
			});
	},

	getPollResponseId({state, commit}, payload) {
		return new Promise((resolve, reject) => {
			axios.get('/api/v3/quiz-maker/quizzes/' + payload + '/user/' + user.id +'/last')
				.then((response)  => {

					if (response.data) {
						//get the last answered question
						let last_user_response = response.data;

						//update the response id
						commit('setResponses', last_user_response );
					}

					resolve(response);
				}, error => {
					reject(error);
				});
		});
	},

	getCurrentProgress({state, commit}, payload) {
		let response_id = payload;
		axios.get('/api/v3/quiz-maker/responses/' + response_id)
			.then(function (response) {
				commit('updateProgress', response);
			}, error => {
				reject(error);
			});
	},

	getQuestion({state, commit}, payload) {
		return axios.get('/api/v3/quiz-maker/quizzes/'+payload+'/questions')
			.then((response) => {
				response.quiz_id = payload;
				commit('setQuestions', response);
			}).catch(() => {
				alert('The quiz was unable to load. Please try again at a later time.');
			});
	},

	getUserResponses({state, commit}, payload) {
		return axios.get('/api/v3/quiz-maker/quizzes/'+payload+'/stats')
			.then((response) => {
				let data = {
					response: response.data.data.questions[0].responses,
					quiz_id: payload
				};
				commit('setAllUserResponses', data);
			}).catch(() => {
				alert('The quiz was unable to load. Please try again at a later time.');
			});
	},

	getQuestionMedia({context, commit}, payload) {
		return axios.get('/api/v3/quiz-maker/questions/' + payload + '/media')
			.then(function (response) {
				commit('setQuestionMedia', response.data.data);
			}).catch((response) => {
			});
	},

	postAnswer({context, commit}, payload) {
		return new Promise((resolve, reject) => {
			let headers = {
				headers: {
					'user_id': payload.user_id,
				}
			};
			axios.post('/api/v3/quiz-maker/responses/', payload, headers)
				.then((response) => {
					commit('setResponseId',response.data.data.response_id);

					// this.commit('quiz/confirmAnswer', response.data.data.response);

					resolve(response);
				}, error => {
					reject();
				});
		});
	},

	updatePoll(context, payload) {
		return new Promise((resolve, reject) => {
			axios.put('/api/v3/quiz-maker/questions/' + payload.id, payload).then((response) => {

				resolve(response.data.data);

				for (let i in  payload.question_options) {
					let option = payload.question_options[i];

					if (option.id) {
						context.dispatch('updateOption', option);
					} else {
						let new_option = {
							question_id: option.question_id,
							question_options: [option]
						};
						context.dispatch('storeOption', new_option);
					}
				}

			}, error => {
				reject(error);
			});
		});
	},

	updatePollSettings(context, payload) {
		return new Promise((resolve, reject) => {
			axios.post('/api/v3/quiz-maker/quizzes/' + payload.poll_id + '/settings', payload.settings).then(function (poll) {
				resolve(poll.data.data);
			});
		});
	},

	updateOption(context, payload) {
		let id = payload.question_id;
		let option_id = payload.id;

		axios.put('/api/v3/quiz-maker/questions/' + id + '/options/' + option_id, payload)
			.then(function () {

			});

	},

	storeOption(context, payload) {
		let id = payload.question_id;

		axios.post('/api/v3/quiz-maker/questions/' + id + '/options', payload)
			.then(function () {

			});

	},

	deleteOption(context, payload) {
		let id = payload.question_id;
		let option_id = payload.id;

		payload.context = context;

		axios.post('/api/v3/quiz-maker/questions/' + id + '/options/' + option_id, {_method: 'DELETE'})
			.then(function () {

			});

	},

	deleteAnswer(context, payload) {
		return new Promise((resolve, reject) => {
			axios.post('/api/v3/quiz-maker/responses/', {_method: 'DELETE', response_ids: [payload]})
				.then(function () {
					resolve(true);
				});
		});
	},

	deleteUserResponses(context, payload) {
		return new Promise((resolve, reject) => {
			axios.post('/api/v3/quiz-maker/user-responses/', { _method: 'DELETE', user_response_ids: [payload] })
				.then(function () {
					resolve(true);
				});
		});
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
